import { Component, ElementRef, OnInit, ViewChild, TemplateRef, Output, EventEmitter, HostListener } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router } from "@angular/router";
import { ListingGridService } from "src/app/services/listing-grid.service";
import { ClickStreamAnalyticsService, EventType } from "src/app/services/clickstream-analytics-service";
import { DataResult, DataStateChangeEventArgs, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ChangeDetectorRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SyncfusionService } from "src/app/services/syncfusion.service";
import { AppSettingService } from "src/app/services/app-setting.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReusableFilterMoleculeComponent } from "../../molecules/reusable-filter-molecule/reusable-filter-molecule.component";
import { FilterBayService } from "src/app/services/filter-bay.service";
import { SyncfusionGridComponent } from "../../molecules/syncfusion-grid/syncfusion-grid.component";
import { GridReusableMoleculeComponent } from "../../molecules/grid-reusable-molecule/grid-reusable-molecule.component";

@Component({
  selector: 'app-product-listing-organism',
  templateUrl: './product-listing-organism.component.html',
  styleUrls: ['./product-listing-organism.component.scss']
})
export class ProductListingOrganismComponent implements OnInit {
  pageSize: number;
  currentPage: number = 0;
  latestPage: any;
  executed: boolean;
  isFetchingData: boolean;
  filters: any;
  gridList: any;
  totalRecordCount: number;
  pagesLoaded: number[] = [];
  addFilters;
  showOverlay;
  detectChanges;
  sortFilterOptions: any;
  loading: boolean = true;
  search_with_text: string;
  sortByOption: string;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('productContainer') productContainer!: ElementRef;
  @ViewChild('gridRef') gridRef!: GridReusableMoleculeComponent;
  sortByOnChange: any;
  sortByAsc: boolean = true;
  selectedProductCode: any;
  gridListPayload: {
    pageSize: any,
    pageNumber: any,
    gridFilters: any,
    // sortOption: any,
    searchText: any,
    // sortAsc: any
    sortData: {
      "sortColumn": any,
      "sortDesc": any
    },
  }
  dataSource: any;
  sku;
  isTableView: boolean = false;
  dialogVisible: boolean = false;
  selectedFieldData: any = null;
  selectedHeaderData: string = '';
  @ViewChild('imageTemplate', { static: true }) imageTemplate!: TemplateRef<any>;
  @ViewChild("childFilter", { static: false }) public childComponent !: ReusableFilterMoleculeComponent;
  @Output() dataEmitForPOPUP = new EventEmitter<{}>();
  fieldData: any;
  headerData: any;
  visiblePOPUP: boolean;
  selectedCode: string;
  isSmallScreen: boolean = window.innerWidth < 800;
  // showInformation : boolean =false;
  isDialogVisible: boolean = false;
  queryParams: any = {};
  count: any;
  dynamic_headers: any;
  tableDataFetched: boolean = false;
  reportName: string = 'product_performance';
  showFilter: boolean = false;
  filterData: any;
  showFiltersPopup: boolean = false;
  reportLabelText: string;
  appliedFilters: any = {};
  private isUpdatingParams = false;
  private isLoadingProducts = false;
  showSearchField: boolean = false;
  showSortField: boolean = false;

  constructor(
    private listinggridservice: ListingGridService, private syncfusion: SyncfusionService,
    private route: ActivatedRoute, private settingsService: AppSettingService,
    private router: Router, private snack: MatSnackBar, private filterbayservice: FilterBayService,
    private clickStream: ClickStreamAnalyticsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.sortByAsc = true;
    this.checkScreenSize();
    const savedView = sessionStorage.getItem('viewPreference');
    this.isTableView = savedView === 'table';
    this.pageSize = 50;
    this.selectedProductCode = this.listinggridservice.getSelectedProduct();
    this.filters = [];
    this.route.queryParams.subscribe((params) => {
      if (this.isUpdatingParams) {
        return;
      }
      this.search_with_text = params['searchText'] || '';
      this.sortByOption = params['sortColumn'] || '';
      this.sortByAsc = params['sortDesc'] === 'true';
      if (params['filters']) {
        try {
          this.filters = JSON.parse(params['filters']);
        } catch (e) {
          console.error('Invalid filters param:', params['filters']);
        }
      }
      this.gridListPayload = {
        pageSize: 50,
        pageNumber: 1,
        gridFilters: this.filters,
        searchText: this.search_with_text,
        sortData: {
          "sortColumn": this.sortByOption,
          "sortDesc": this.sortByAsc
        },
      };
      this.updateQueryParams(this.gridListPayload);
      this.getFilters();
      this.loadProducts();
    });
  }
  @HostListener('window:resize', [])
  onResize(): void {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isSmallScreen = window.innerWidth < 800;
  }
  setView(view: string): void {
    this.isTableView = view === 'table';
    sessionStorage.setItem('viewPreference', view);
  }
  onProductClick(event: any): void {
    const selectedRowData = event.data;
    const skuCode = selectedRowData.code;
    this.router.navigate(['/product/listing', { code: skuCode }]);
  }
  updateQueryParams(params: any) {
    this.isUpdatingParams = true;
    this.queryParams = {};
    if (params.searchText) {
      this.queryParams.searchText = params.searchText.trim();
    }
    if (params.sortData.sortColumn) {
      this.queryParams.sortColumn = params.sortData.sortColumn;
    }
    if (params.sortData.sortDesc) {
      this.queryParams.sortDesc = true;
    }
    if (params.gridFilters && params.gridFilters.length > 0) {
      this.queryParams.filters = JSON.stringify(params.gridFilters);
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.queryParams,
    });
    setTimeout(() => {
      this.isUpdatingParams = false;
    }, 100);
  }
  onRightClick(event: MouseEvent, item: any) {
    event.preventDefault();
    const skuCode = item.product;
    const url = `${window.location.origin}/product/listing;code=${skuCode}`;
    window.open(url, '_blank');
  }
  onOverlayClick() {
    this.dialogVisible = false;
  }

  loadProducts() {
    if (this.isLoadingProducts) {
      return;
    }
    this.isLoadingProducts = true;
    this.loading = true;
    this.tableDataFetched = false;
    if (this.settingsService.isRemoteGridMode()) {
      this.syncfusion.getPaginatedSyncfusionData(this.reportName, this.gridListPayload).subscribe((res) => {
        if (res) {
          this.gridList = res["items"];
          this.dynamic_headers = JSON.parse(res["headerContent"]);
          this.dataSource = (<DataResult>{
            result: res["items"],
            count: res["pageData"] ? res["pageData"]["totalRecords"] : res["count"]
          });
          this.showSearchField = this.dynamic_headers.some(header => header.isSearchable);
          this.showSortField = this.dynamic_headers.some(header => header.isSortable);
          this.sortFilterOptions = this.dynamic_headers
            .filter(header => header.isSortable)
            .map(header => ({
              label: header.headerText,
              value: header.field
            }));
          const pageData = res["pageData"];
          this.pageSize = pageData["pageSize"];
          this.gridListPayload.pageNumber = pageData["pageNumber"]
          this.currentPage = pageData["pageNumber"] - 1;
          this.totalRecordCount = pageData["totalRecords"];
          this.count = res["count"];
          this.syncfusion.setExportData(res);
          this.loading = false;
          this.isLoadingProducts = false;
          this.cdr.detectChanges();
          if (null != pageData["searchText"]) {
            this.search_with_text = pageData["searchText"];
          }
          if (null != pageData["sortData"]["sortColumn"]) {
            this.sortByOption = pageData["sortData"]["sortColumn"];
          }
          if (null != pageData["sortData"]["sortDesc"]) {
            this.sortByAsc = pageData["sortData"]["sortDesc"];
          }
          this.filters = pageData["gridFilters"] || [];
          setTimeout(() => {
            this.tableDataFetched = true;
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        this.isLoadingProducts = false;
        console.error(error);
      })
    } else {
      this.syncfusion.getSyncfusionData(this.reportName).then((res) => {
        if (res) {
          this.gridList = res["items"];
          this.dynamic_headers = JSON.parse(res["headerContent"]);
          this.showSearchField = this.dynamic_headers.some(header => header.isSearchable);
          this.showSortField = this.dynamic_headers.some(header => header.isSortable);
          this.sortFilterOptions = this.dynamic_headers
            .filter(header => header.isSortable)
            .map(header => ({
              label: header.headerText,
              value: header.field
            }));
          this.dataSource = res["items"];
          const pageData = res["pageData"];
          this.pageSize = pageData["pageSize"];
          this.currentPage = pageData["pageNumber"] - 1;
          this.totalRecordCount = pageData["totalRecords"];
          this.count = res["count"];
          this.syncfusion.setExportData(res);
          this.loading = false;
          this.isLoadingProducts = false;
          this.cdr.detectChanges();
          if (null != pageData["searchText"]) {
            this.search_with_text = pageData["searchText"];
          }
          if (null != pageData["sortData"]["sortColumn"]) {
            this.sortByOption = pageData["sortData"]["sortColumn"];
          }
          if (null != pageData["sortData"]["sortDesc"]) {
            this.sortByAsc = pageData["sortData"]["sortDesc"];
          }
          this.filters = pageData["gridFilters"] || [];
          setTimeout(() => {
            this.tableDataFetched = true;
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        this.isLoadingProducts = false;
        console.error(error);
      });
    }
  }

  handleFilterOutput(event) {
    this.showOverlay = false;
    this.filters = event;
    this.gridListPayload.gridFilters = this.filters;
    this.updateQueryParams(this.gridListPayload);
    this.clickStream.publishGAEvent(EventType.FILTER, {
      section: this.reportName
    });
    this.loadProducts()
  }

  showFilters() {
    this.showFiltersPopup = !this.showFiltersPopup;
    if (this.showFiltersPopup) {
      this.childComponent.createOverlay();
    }
  }
  clickToNextPage(event) {
    const pageIndex = event.pageIndex + 1;
    this.gridListPayload.pageNumber = pageIndex;
    this.loadProducts();
  }

  searchWithText() {
    this.gridListPayload.searchText = this.search_with_text;
    this.updateQueryParams(this.gridListPayload);
    this.clickStream.publishGAEvent(EventType.SEARCH, {
      value: this.search_with_text,
      section: "Product Listing"
    });
    this.loadProducts();
  }

  sortByAscOrDes() {
    this.sortByAsc = !this.sortByAsc;
    this.gridListPayload.sortData.sortDesc = this.sortByAsc;
    this.updateQueryParams(this.gridListPayload);
    this.clickStream.publishGAEvent(EventType.SORT, {
      value: this.sortByOnChange,
      section: "Product Listing"
    });
    this.loadProducts();
  }

  handleValueChange(event) {
    this.sortByOnChange = event;
    this.gridListPayload.sortData.sortColumn = event;
    this.updateQueryParams(this.gridListPayload);
    this.loadProducts();
  }

  onInputChange(event) {
    if (this.search_with_text?.length === 0) {
      this.gridListPayload.searchText = "";
      this.updateQueryParams(this.gridListPayload);
      this.loadProducts();
    }
  }

  ngAfterViewInit() {
    if (null != this.selectedProductCode && null != this.productContainer) {
      let count = 0;
      const intervalId = setInterval(() => {
        count += 1;
        if (count === 6) {
          clearInterval(intervalId);
        }
        const selectedProductElement = this.productContainer.nativeElement
          .querySelector(`[data-code="${this.selectedProductCode}"]`);
        if (null != selectedProductElement) {
          selectedProductElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          clearInterval(intervalId);
        }
      }, 1000);
    }
  }
  handlePOPUP(event) {
    this.fieldData = event.fieldData;
    this.headerData = event.header;
    this.visiblePOPUP = true;
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  getFilters() {
    this.syncfusion.getAvailableFilters(this.reportName).subscribe((res: any) => {
      this.filterData = res?.filterDataList;
      this.filterData = this.filterData.sort((a, b) => a.position - b.position);
      this.showFilter = this.filterData.length > 0;
      this.clickStream.publishGAEvent(EventType.FILTER, {
        section: this.reportName
      });
    }, (error) => {
      this.showSnackbar('Error while fetching filters.Please try again later');
    })
  }
  selectedFilters(event) {
    if (event && event.filters) {
      this.appliedFilters = JSON.parse(JSON.stringify(event.filters));
    } else {
      this.appliedFilters = JSON.parse(JSON.stringify(event));
    }
    setTimeout(() => {
      // console.log('After timeout, appliedFilters:', this.appliedFilters);
    }, 100);
  }

  navigateGrid(state: DataStateChangeEventArgs) {
    if ((state as any).action?.requestType === 'filterchoicerequest' || (state as any).action?.requestType === 'stringfilterrequest' ||
      (state as any).action?.requestType === 'filtersearchbegin' || (state as any).action?.requestType === 'filterbeforeopen') {
      return;
    }
    const pageData = this.syncfusion.convertGridStateToPageData(state);
    pageData.gridFilters = this.gridListPayload.gridFilters;
    pageData.sortData = this.gridListPayload.sortData;
    pageData.searchText = this.gridListPayload.searchText

    const payload = { ...pageData };
    this.syncfusion.getPaginatedSyncfusionData(this.reportName, payload).subscribe((res) => {
      if (res) {
        this.gridList = res["items"];
        this.dataSource = (<DataResult>{
          result: res.items,
          count: res.pageData ? res.pageData.totalRecords : res.count
        });
        this.reportLabelText = res.baseReportText;
        this.syncfusion.setExportData(res);
        setTimeout(() => {
          this.tableDataFetched = true;
        });
      }
    }, (error) => {
      this.tableDataFetched = true;
      console.error(error);
      this.showSnackbar("Error while fetching report");
    })

  }
}